export function normalizeGradeDiscriminator(discriminator?: string | null): string {
  if (!discriminator) {
    return 'TubularPipe';
  }

  const value = discriminator.trim();
  const normalizedMap: Record<string, string> = {
    tubularpipe: 'TubularPipe',
    tubularPipe: 'TubularPipe',
    TubularPipe: 'TubularPipe',
    drillpipe: 'DrillPipe',
    drillPipe: 'DrillPipe',
    DrillPipe: 'DrillPipe',
    hwdp: 'Hwdp',
    Hwdp: 'Hwdp',
    collar: 'Collar',
    collars: 'Collar',
    Collar: 'Collar'
  };

  return normalizedMap[value] ?? value;
}

export function filterGradesByTypeAndName<T extends { name?: string; discriminator?: string | null }>(
  grades: T[],
  selectedType: string | null | undefined,
  filterText: string | null | undefined
): T[] {
  const type = normalizeGradeDiscriminator(selectedType ?? 'TubularPipe');
  const trimmedFilter = (filterText ?? '').trim().toLowerCase();

  return grades.filter((grade) => {
    const matchesType = normalizeGradeDiscriminator(grade?.discriminator) === type;
    const matchesText = !trimmedFilter || (grade?.name ?? '').toLowerCase().includes(trimmedFilter);
    return matchesType && matchesText;
  });
}
